import { ReactElement } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../redux/store';
import { eventActions } from '../../redux/slices/event.slice';
import { IAssociation } from '../../types/@association';
import { EEventCreateSteps } from '../../types/@event';

interface IProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const EventCreateAssociation = ({ setStep }: IProps): ReactElement => {
  const dispatch = useDispatch();
  const associations = useSelector((state: RootState) => state.associations.all);

  const handleSelect = (association: IAssociation): void => {
    dispatch(eventActions.selectedAssociation(association));
    setStep(EEventCreateSteps.organisation);
  };

  const handleBack = (): void => {
    setStep(EEventCreateSteps.type);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '920px', margin: '0 auto', padding: '48px 24px' }}>
      <Typography sx={{ fontSize: '32px', fontWeight: 700, marginBottom: '24px' }}>
        Select association
      </Typography>

      <Box sx={{ display: 'grid', gap: '16px' }}>
        {associations.map((association: IAssociation) => (
          <Box
            key={association._id}
            sx={{
              border: '1px solid #ddd',
              borderRadius: '12px',
              padding: '20px',
              cursor: 'pointer',
            }}
            onClick={() => handleSelect(association)}
          >
            <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>{association.name}</Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px' }}>
        <Button onClick={handleBack}>Back</Button>
      </Box>
    </Box>
  );
};

export default EventCreateAssociation;